import { render } from "./Neighborhood.vue?vue&type=template&id=57636e4e&scoped=true"
import script from "./Neighborhood.vue?vue&type=script&lang=js"
export * from "./Neighborhood.vue?vue&type=script&lang=js"

import "./Neighborhood.vue?vue&type=style&index=0&id=57636e4e&scoped=true&lang=css"

import exportComponent from "/Users/pongsakornsomsri/workspace/neera-retreat-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57636e4e"]])

export default __exports__